var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Performance & Alerts",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "performance-alerts-header" }, [
                    _c(
                      "div",
                      { staticClass: "performance-alerts-header__top mb-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "performance-alerts-tabs" },
                          _vm._l(_vm.reportTabs, function (tab) {
                            return _c(
                              "b-button",
                              {
                                key: tab.key,
                                staticClass: "performance-alerts-tab-btn",
                                attrs: {
                                  size: "sm",
                                  variant:
                                    _vm.activeTab === tab.key
                                      ? "primary"
                                      : "outline-secondary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.setActiveTab(tab.key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(tab.label) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "performance-alerts-header__bottom d-flex justify-content-between align-items-start flex-wrap",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-wrap align-items-center",
                          },
                          [
                            _vm.shouldShowGlobalDateFilters
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "mr-3 mb-2 mb-md-0" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-uppercase" },
                                        [_vm._v("From:")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.formattedStartDate) +
                                          "\n                "
                                      ),
                                      _c("b-form-datepicker", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          max: _vm.maxDate,
                                          "button-only": "",
                                          "button-variant": "primary",
                                        },
                                        on: { input: _vm.onStartDateChanged },
                                        model: {
                                          value: _vm.globalFilters.date_from,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.globalFilters,
                                              "date_from",
                                              $$v
                                            )
                                          },
                                          expression: "globalFilters.date_from",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mr-3 mb-2 mb-md-0" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-uppercase" },
                                        [_vm._v("To:")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.formattedEndDate) +
                                          "\n                "
                                      ),
                                      _c("b-form-datepicker", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          max: _vm.maxDate,
                                          "button-only": "",
                                          "button-variant": "primary",
                                        },
                                        on: { input: _vm.onEndDateChanged },
                                        model: {
                                          value: _vm.globalFilters.date_to,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.globalFilters,
                                              "date_to",
                                              $$v
                                            )
                                          },
                                          expression: "globalFilters.date_to",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeTab === "wow_order_volume_change"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "mr-3 mb-2 mb-md-0" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-uppercase" },
                                        [_vm._v("Accounts:")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        staticClass:
                                          "d-inline-block ml-2 report-inline-select",
                                        attrs: {
                                          options: _vm.wowAccountScopeOptions,
                                        },
                                        on: { change: _vm.onFiltersChanged },
                                        model: {
                                          value:
                                            _vm.filtersByTab
                                              .wow_order_volume_change
                                              .account_scope,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filtersByTab
                                                .wow_order_volume_change,
                                              "account_scope",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filtersByTab.wow_order_volume_change.account_scope",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mr-3 mb-2 mb-md-0" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-uppercase" },
                                        [_vm._v("Alert Threshold:")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass:
                                          "d-inline-block ml-2 report-inline-input",
                                        attrs: {
                                          type: "number",
                                          min: "1",
                                          max: "100",
                                          step: "1",
                                        },
                                        on: { change: _vm.onFiltersChanged },
                                        model: {
                                          value:
                                            _vm.filtersByTab
                                              .wow_order_volume_change
                                              .decline_threshold_percent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filtersByTab
                                                .wow_order_volume_change,
                                              "decline_threshold_percent",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "filtersByTab.wow_order_volume_change.decline_threshold_percent",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.activeTab === "order_source_mix"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "mr-3 mb-2 mb-md-0" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-uppercase" },
                                        [_vm._v("Min GL Share:")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass:
                                          "d-inline-block ml-2 report-inline-input",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          max: "100",
                                          step: "1",
                                        },
                                        on: { change: _vm.onFiltersChanged },
                                        model: {
                                          value:
                                            _vm.filtersByTab.order_source_mix
                                              .min_gl_share,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filtersByTab.order_source_mix,
                                              "min_gl_share",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "filtersByTab.order_source_mix.min_gl_share",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "b-btn",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "primary",
                                  title: "Export PDF",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.downloadPdf.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_c("b-icon-file-earmark-pdf")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-btn",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "primary",
                                  title: "Reload Report",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.reloadCurrentReport.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_c("b-icon-arrow-clockwise")],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "performance-alerts-summary mb-3" }, [
            _c("div", { staticClass: "text-muted" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.currentReportConfig.description || "Report overview"
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.currentAlerts.length
            ? _c(
                "div",
                { staticClass: "performance-alerts-alerts mb-3" },
                _vm._l(_vm.currentAlerts, function (alert) {
                  return _c(
                    "div",
                    {
                      key: alert.id || `${alert.title}-${alert.message}`,
                      staticClass: "performance-alerts-alert",
                      class: _vm.getAlertClass(alert),
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "performance-alerts-alert__title" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(alert.title || "Alert") +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "performance-alerts-alert__message" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(alert.message || "-") +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      alert.threshold ||
                      alert.value ||
                      alert.account_name ||
                      alert.seller_name
                        ? _c(
                            "div",
                            { staticClass: "performance-alerts-alert__meta" },
                            [
                              alert.account_name || alert.seller_name
                                ? _c("span", { staticClass: "mr-3" }, [
                                    _c("strong", [_vm._v("Account:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          alert.account_name ||
                                            alert.seller_name
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              typeof alert.value !== "undefined" &&
                              alert.value !== null
                                ? _c("span", { staticClass: "mr-3" }, [
                                    _c("strong", [_vm._v("Value:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.formatAlertValue(alert)) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              alert.threshold
                                ? _c("span", [
                                    _c("strong", [_vm._v("Threshold:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(alert.threshold) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-table", {
            attrs: {
              fields: _vm.currentReportColumns,
              items: _vm.currentReportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No data found",
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.sortableHeaderColumns, function (column) {
                  return {
                    key: `head(${column.key})`,
                    fn: function () {
                      return [
                        _c(
                          "button",
                          {
                            key: `sort-${column.key}`,
                            staticClass:
                              "report-sort-head btn btn-link p-0 d-inline-flex align-items-center",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort(column.key)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(column.label))]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.sortIcon(column.key))),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                }),
                {
                  key: "cell(current_period_value)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatCurrency(data.item.current_period_value)
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(prior_period_value)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatCurrency(data.item.prior_period_value)
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(account_type)",
                  fn: function (data) {
                    return [
                      _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.item.account_type || "-") +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(approved_at)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(data.item.approved_at)) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(change_percent)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "trajectory-badge",
                          class: _vm.getChangeClass(
                            data.item.change_percent,
                            data.item.decline_threshold_percent
                          ),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatPercent(data.item.change_percent)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(severity)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "wow-status-badge",
                          class: _vm.getWowSeverityClass(data.item.severity),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getWowSeverityLabel(data.item.severity)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(percent_orders)",
                  fn: function (data) {
                    return [
                      _vm.isGlShareBelowThreshold(data.item)
                        ? _c("span", [
                            _vm._v(
                              "\n          🔴 Critical (" +
                                _vm._s(
                                  _vm.formatPlainPercent(
                                    data.item.percent_orders
                                  )
                                ) +
                                ")\n        "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formatPlainPercent(
                                    data.item.percent_orders
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                    ]
                  },
                },
                {
                  key: "cell(coverage_percent)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "coverage-badge",
                          class: _vm.getCoverageClass(
                            data.item.coverage_percent
                          ),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatPercent(data.item.coverage_percent)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(last_order_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(data.item.last_order_date)) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(signup_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(data.item.signup_date)) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(first_value_date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(data.item.first_value_date)) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(time_to_first_value_days)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatDays(data.item.time_to_first_value_days)
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(previous_avg_order_value)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatCurrency(
                              data.item.previous_avg_order_value
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(current_avg_order_value)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.formatCurrency(
                              data.item.current_avg_order_value
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(adoption_percent)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "coverage-badge",
                          class: _vm.getCoverageClass(
                            data.item.adoption_percent
                          ),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatPercent(data.item.adoption_percent)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(engagement_percent)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "coverage-badge",
                          class: _vm.getCoverageClass(
                            data.item.engagement_percent
                          ),
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatPercent(data.item.engagement_percent)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }